import React from "react";
import { QuestionText } from "./questionText.styles";

const Title = ({ text, isAlreadyAnswered }) => (
  <QuestionText isAlreadyAnswered={isAlreadyAnswered} dir="auto">
    {text}
  </QuestionText>
);

export default Title;
